export function EncodeFilter(
    $window
) {
    'ngInject';

    return encode;


    /**
     * URL-encode a string
     *
     * @param {String} input
     * @return {String} output
     */
    function encode(input) {
        return $window.encodeURIComponent(input);
    }

}




/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/encode.filter.js
 **/